export default __webpack_public_path__ + "static/project-slide-7-1640-765-17bb5813d8b3083dfe66478e923aae6c.webp";